<template>
  <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
          data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
          class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
          <span class="h-20px border-gray-300 border-start mx-4"></span>
          <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
            <div v-for="(bread, key) in breadcrumbs" :key="key">
              <div>
                <li class="breadcrumb-item text-muted" v-if="key + 1 !== breadcrumbs.length">
                  <router-link :to="bread.path" class="text-muted text-hover-primary">{{ $t(bread.name) }}</router-link>
                </li>
                <li v-else class="breadcrumb-item text-dark">{{ $t(bread.name) }}</li>
              </div>
            </div>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <div class="m-0">
            <select name="filter" style="width:250px!important;" v-model="shop_selected" data-control="select2"
              data-search="true" data-placeholder="Filter"
              class="form-select kt_select_vente form-select-sm border-primary w-200px me-5">
              <option :value="'all'" selected>{{ $t('dashboard.all_shop') }}</option>
              <option v-if="$hasModule('ecommerce')" :value="'ecommerce'">{{ $t('dashboard.ecommerce') }}</option>
              <option v-for="filter in shops" :value="filter.id" :key="filter.id">{{ filter.name }}</option>
            </select>
          </div>
          <div class="card-toolbar">
            <div dashboard-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
              class="btn btn-sm btn-light d-flex align-items-center px-4">
              <div class="text-gray-600 fw-bolder">{{ $t('dashboard.loading') }}...</div>
              <span class="svg-icon svg-icon-1 ms-2 me-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"/>
                  <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"/>
                  <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div v-show="isReady" id="kt_content_container" class="container-xxl">

        <!-- ── KPI Cards ── -->
        <div class="d-flex gap-5 flex-wrap mb-8">

          <!-- Clients -->
          <div class="kpi-card flex-grow-1" style="min-width:200px">
            <div class="kpi-icon-box" style="background:rgba(0,158,247,0.1)">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" fill="#009EF7"/>
                <path opacity="0.3" d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" fill="#009EF7"/>
              </svg>
            </div>
            <div class="flex-grow-1">
              <div class="kpi-big-number">{{ contacts }}</div>
              <div class="text-gray-500 fw-semibold fs-6">{{ $t('dashboard.customers') }}</div>
            </div>
          </div>

          <!-- Produits -->
          <div class="kpi-card flex-grow-1" style="min-width:200px">
            <div class="kpi-icon-box" style="background:rgba(80,205,137,0.1)">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M4 4H20C20.6 4 21 4.4 21 5V19C21 19.6 20.6 20 20 20H4C3.4 20 3 19.6 3 19V5C3 4.4 3.4 4 4 4Z" fill="#50CD89"/>
                <path d="M9 9H15C15.6 9 16 8.6 16 8C16 7.4 15.6 7 15 7H9C8.4 7 8 7.4 8 8C8 8.6 8.4 9 9 9ZM9 13H15C15.6 13 16 12.6 16 12C16 11.4 15.6 11 15 11H9C8.4 11 8 11.4 8 12C8 12.6 8.4 13 9 13ZM9 17H12C12.6 17 13 16.6 13 16C13 15.4 12.6 15 12 15H9C8.4 15 8 15.4 8 16C8 16.6 8.4 17 9 17Z" fill="#50CD89"/>
              </svg>
            </div>
            <div class="flex-grow-1">
              <div class="kpi-big-number">{{ products }}</div>
              <div class="text-gray-500 fw-semibold fs-6">{{ $t('dashboard.products') }}</div>
            </div>
          </div>

          <!-- CA -->
          <div class="kpi-card flex-grow-1" style="min-width:200px">
            <div class="kpi-icon-box" style="background:rgba(114,57,234,0.1)">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="#7239EA"/>
                <path d="M14.5 7H9.5C8.67157 7 8 7.67157 8 8.5C8 9.32843 8.67157 10 9.5 10H14.5C15.3284 10 16 9.32843 16 8.5C16 7.67157 15.3284 7 14.5 7Z" fill="#7239EA"/>
                <path d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14H9.5C8.67157 14 8 13.3284 8 12.5C8 11.6716 8.67157 11 9.5 11H14.5C15.3284 11 16 11.6716 16 12.5C16 13.3284 15.3284 14 14.5 14H13V17Z" fill="#7239EA"/>
              </svg>
            </div>
            <div class="flex-grow-1">
              <div class="kpi-big-number">
                {{ turnover }} <small class="fs-5 fw-normal text-muted">{{ currency }}</small>
              </div>
              <div class="text-gray-500 fw-semibold fs-6">{{ $t('dashboard.turnover') }}</div>
            </div>
          </div>

        </div>

        <!-- ── Row 1 : Ventes par période + par heure ── -->
        <div class="row gy-5 g-xl-8 mb-5">
          <div class="col-lg-6">
            <div class="card dashboard-card h-100">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(0,158,247,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M2 13H10V21H2V13ZM14 5H22V21H14V5Z" fill="#009EF7"/>
                      <path d="M2 3H10V12H2V3ZM14 3H22V4H14V3Z" fill="#009EF7"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.sale_by_period') }}</div>
                    <div class="fs-7 text-muted fw-semibold">Évolution du chiffre d'affaires</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="salesByPeriodEmpty" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else id="sale-periode-chart" style="height:300px"></div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card dashboard-card h-100">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(80,205,137,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <rect x="2" y="14" width="4" height="8" rx="1" fill="#50CD89"/>
                      <rect x="8" y="9" width="4" height="13" rx="1" fill="#50CD89" opacity="0.7"/>
                      <rect x="14" y="5" width="4" height="17" rx="1" fill="#50CD89" opacity="0.5"/>
                      <rect x="20" y="2" width="4" height="20" rx="1" fill="#50CD89" opacity="0.3"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.sale_by_hour') }}</div>
                    <div class="fs-7 text-muted fw-semibold">{{ heatPeak || $t('statistics.by_hour_help') }}</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="salesByHourEmpty" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <!-- Les heures de pointe : une grille jour × heure, une teinte, plus foncée pour plus de ventes. -->
                <template v-else>
                  <div class="heatmap-scroll">
                    <div class="heatmap" :style="{ '--hours': heatHours.length }">
                      <span></span>
                      <span v-for="hour in heatHours" :key="`h-${hour}`" class="heatmap-hour">{{ hour % 2 === 0 ? `${hour}h` : '' }}</span>
                      <template v-for="day in 7" :key="`d-${day}`">
                        <span class="heatmap-day">{{ $t(`statistics.weekdays.${day}`) }}</span>
                        <span
                          v-for="hour in heatHours"
                          :key="`${day}-${hour}`"
                          class="heatmap-cell"
                          :class="`level-${heatLevel(heatCount(day, hour))}`"
                          :title="heatCount(day, hour) ? $t('statistics.hour_cell', { day: $t(`statistics.weekdays.${day}`), from: hour, to: hour + 1, n: heatCount(day, hour) }, heatCount(day, hour)) : undefined"
                        ></span>
                      </template>
                    </div>
                  </div>
                  <div class="heatmap-legend">
                    <span>{{ $t('statistics.fewer') }}</span>
                    <span v-for="index in 5" :key="index" class="heatmap-cell" :class="`level-${index}`"></span>
                    <span>{{ $t('statistics.more') }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Row 2 : Top 5 articles + Ventes par vendeur ── -->
        <div class="row gy-5 g-xl-8 mb-5">
          <div class="col-lg-6">
            <div class="card dashboard-card h-100">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(255,199,0,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#FFC700"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.top5articles') }}</div>
                    <div class="fs-7 text-muted fw-semibold">Articles les plus vendus sur la période</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="!saleStats?.top_products?.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <template v-else>
                  <!-- Mobile : cards 2 colonnes -->
                  <div v-if="isMobile" class="row g-3">
                    <div v-for="item in saleStats.top_products" :key="item.name" class="col-6">
                      <div class="cat-stat-card">
                        <div class="cat-stat-name">{{ item.name }}</div>
                        <div class="cat-stat-value" style="color:#FFC700">
                          {{ $formatLocalAmount(item.sales) }}
                          <small class="cat-stat-currency">{{ currency }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Desktop : graphe -->
                  <div v-else id="top5-articles-chart" style="height:300px"></div>
                </template>
              </div>
            </div>
          </div>

          <div class="col-lg-6" v-show="shop_selected !== 'ecommerce'">
            <div class="card dashboard-card h-100">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(241,65,108,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M20 3H4C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V5C22 3.89543 21.1046 3 20 3Z" fill="#F1416C"/>
                      <path d="M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z" fill="#F1416C"/>
                      <path d="M7 18C7 15.7909 9.23858 14 12 14C14.7614 14 17 15.7909 17 18H7Z" fill="#F1416C"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.employer_sale') }}</div>
                    <div class="fs-7 text-muted fw-semibold">Performance par vendeur</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="!saleStats?.sales_by_employee?.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <template v-else>
                  <!-- Mobile : leaderboard -->
                  <div v-if="isMobile" class="client-leaderboard">
                    <div
                      v-for="(c, i) in saleStats.sales_by_employee"
                      :key="c.employee_lastname + c.employee_firstname"
                      class="leaderboard-row"
                      :class="i === 0 ? 'leaderboard-row--gold' : i === 1 ? 'leaderboard-row--silver' : i === 2 ? 'leaderboard-row--bronze' : ''"
                    >
                      <div class="leaderboard-rank">
                        <span v-if="i === 0">🥇</span>
                        <span v-else-if="i === 1">🥈</span>
                        <span v-else-if="i === 2">🥉</span>
                        <span v-else class="leaderboard-rank-num">{{ i + 1 }}</span>
                      </div>
                      <div class="leaderboard-avatar" :style="{ background: employeeAvatarColor(i) }">
                        {{ employeeInitials(c.employee_firstname, c.employee_lastname) }}
                      </div>
                      <div class="leaderboard-info">
                        <div class="leaderboard-name-wrap">{{ c.employee_firstname }} {{ c.employee_lastname }}</div>
                        <div class="leaderboard-amount-below">
                          {{ $formatLocalAmount(c.sales) }} <small>{{ currency }}</small>
                        </div>
                        <div class="leaderboard-bar">
                          <div class="leaderboard-bar-fill leaderboard-bar-fill--employee"
                            :style="{ width: Math.round(c.sales / (saleStats.sales_by_employee[0]?.sales || 1) * 100) + '%' }">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Desktop : graphe -->
                  <div v-else id="sales-employee-chart" style="height:300px"></div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Row 3 : Promotions ── -->
        <div class="row gy-5 g-xl-8 mb-5">
          <div class="col-lg-6">
            <div class="card dashboard-card" style="min-height:420px">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(0,158,247,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M18.4 5.59998C21.9 9.09998 21.9 14.8 18.4 18.3C14.9 21.8 9.2 21.8 5.7 18.3L18.4 5.59998Z" fill="#009EF7"/>
                      <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12.8 16.8L8.7 15.3L6.5 12L8.7 8.7L12.8 7.2L16.9 8.7L19.1 12L16.9 15.3L12.8 16.8Z" fill="#009EF7"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.promotionTurnover') }}</div>
                    <div class="fs-7 text-muted fw-semibold">CA et réductions par promotion</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-show="promotiontMostSalesAmountEmpty" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div id="chartdiv_promotion" style="height:300px" v-show="!promotiontMostSalesAmountEmpty"></div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card dashboard-card" style="min-height:420px">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(114,57,234,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M22 7H20V5C20 4.4 19.6 4 19 4H5C4.4 4 4 4.4 4 5V7H2C1.4 7 1 7.4 1 8V14C1 14.6 1.4 15 2 15H4V19C4 19.6 4.4 20 5 20H19C19.6 20 20 19.6 20 19V15H22C22.6 15 23 14.6 23 14V8C23 7.4 22.6 7 22 7Z" fill="#7239EA"/>
                      <path d="M14 8.5C14 8.5 14 8.3 14 8V6C14 5.7 14 5.5 14 5.5C14 5.5 13.8 5.5 13.5 5.5H10.5C10.2 5.5 10 5.5 10 5.5C10 5.5 10 5.7 10 6V8C10 8.3 10 8.5 10 8.5C10 8.5 10.2 8.5 10.5 8.5H13.5C13.8 8.5 14 8.5 14 8.5Z" fill="#7239EA"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.promotionNbreSales') }}</div>
                    <div class="fs-7 text-muted fw-semibold">CA et réductions par code promo</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-show="promotionMostSalesNumberEmpty" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div id="chartdiv_codepromo" style="height:300px" v-show="!promotionMostSalesNumberEmpty"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Row 4 : Fidélité ── -->
        <div v-if="$hasModule('loyalty')" class="row gy-5 g-xl-8 mb-5">
          <div class="col-12">
            <div class="card dashboard-card">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(var(--kt-primary-rgb, 11, 61, 135),0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M12 2L14.5 8.5L21.5 9.2L16 13.6L17.7 20.5L12 16.8L6.3 20.5L8 13.6L2.5 9.2L9.5 8.5L12 2Z" fill="#0b3d87"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.loyalty') }}</div>
                    <div class="fs-7 text-muted fw-semibold">{{ $t('statistics.loyalty_subtitle') }}</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div class="row g-5 mb-5">
                  <div class="col-6 col-lg-4">
                    <div class="cat-stat-card">
                      <div class="cat-stat-name">{{ $t('statistics.loyalty_orders') }}</div>
                      <div class="cat-stat-value" style="color:#0b3d87">{{ loyaltyStats.orders_count ?? 0 }}</div>
                    </div>
                  </div>
                  <div class="col-6 col-lg-4">
                    <div class="cat-stat-card">
                      <div class="cat-stat-name">{{ $t('statistics.loyalty_ca') }}</div>
                      <div class="cat-stat-value" style="color:#50CD89">
                        {{ $formatLocalAmount(loyaltyStats.ca ?? 0) }} <small class="cat-stat-currency">{{ currency }}</small>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-lg-4">
                    <div class="cat-stat-card">
                      <div class="cat-stat-name">{{ $t('statistics.loyalty_discount') }}</div>
                      <div class="cat-stat-value" style="color:#F1416C">
                        {{ $formatLocalAmount(loyaltyStats.total_discount ?? 0) }} <small class="cat-stat-currency">{{ currency }}</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="!loyaltyStats.rewards?.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-row-dashed align-middle gy-3">
                    <thead>
                      <tr class="text-muted fw-bold fs-7 text-uppercase">
                        <th>{{ $t('statistics.loyalty_reward') }}</th>
                        <th class="text-end">{{ $t('statistics.loyalty_usage_count') }}</th>
                        <th class="text-end">{{ $t('statistics.loyalty_discount') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in loyaltyStats.rewards" :key="item.label">
                        <td class="fw-semibold">{{ item.label }}</td>
                        <td class="text-end">{{ item.usage_count }}</td>
                        <td class="text-end fw-bold" style="color:#F1416C">{{ $formatLocalAmount(item.total_discount) }} {{ currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Loader -->
      <div class="container-xxl" v-show="!isReady">
        <Loader text="Loading..." />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";

export default {
  components: { Loader },
  data() {
    return {
      title: "navigation.statistique",
      breadcrumbs: [
        { name: 'navigation.sales', path: '/admin' },
      ],
      startDate: null,
      endDate: null,
      shops: [],
      shop_selected: 'all',
      contacts: 0,
      products: 0,
      contactTotal: 0,
      productTotal: 0,
      turnover: 0,
      turnoverTotal: 0,
      currency: '',
      saleStats: {},
      isReady: false,
      iso: '',
      promotionStatData: [],
      codePromoStatData: [],
      loyaltyStats: {},
      isMobile: window.innerWidth <= 767,
      // chart instances
      salesChartPeriod: null,
      top5Chart: null,
      employeeSalesChart: null,
      promotionChart: null,
      codePromoChart: null,
    }
  },

  watch: {
    shop_selected: async function (value) {
      if (value) {
        this.$nextTick(async () => await this.drawCharts())
      }
    },
    '$i18n.locale': function (value) {
      if (value) {
        this.$nextTick(() => this.initDateRange())
      }
    }
  },

  computed: {
    promotiontMostSalesAmountEmpty() {
      return !this.promotionStatData?.length
    },
    promotionMostSalesNumberEmpty() {
      return !this.codePromoStatData?.length
    },
    // sales_by_period/sales_by_hour couvrent toujours toute la plage de
    // dates/heures (une entrée par jour / par heure, valeur 0 par défaut) —
    // le tableau n'est donc jamais vide, même sans aucune vente. "Pas de
    // données" veut dire ici "toutes les valeurs sont à zéro", pas "tableau
    // vide", sinon le graphique (plat à zéro) s'affiche à la place du
    // message "aucune donnée".
    salesByPeriodEmpty() {
      const data = this.saleStats?.sales_by_period
      return !data?.length || !data.some(d => Number(d.value) > 0)
    },
    salesByHourEmpty() {
      const data = this.saleStats?.sales_by_hour
      return !data?.length || !data.some(d => Number(d.sales_count) > 0)
    },
    // Les heures de pointe (sales_by_weekday_hour : jour 1 lundi … 7 dimanche × heure, seulement les cases avec
    // des ventes). Les heures montrées vont de la première à la dernière vente, 8 h – 20 h au moins.
    heatCells() {
      return new Map((this.saleStats?.sales_by_weekday_hour || []).map(cell => [`${cell.weekday}-${cell.hour}`, Number(cell.sales_count)]))
    },
    heatHours() {
      const seen = (this.saleStats?.sales_by_weekday_hour || []).map(cell => Number(cell.hour))
      const first = Math.min(8, ...seen)
      const last = Math.max(20, ...seen)
      return Array.from({ length: last - first + 1 }, (_, index) => first + index)
    },
    heatMax() {
      return Math.max(0, ...this.heatCells.values())
    },
    // Le créneau le plus chargé, écrit en clair sous le titre.
    heatPeak() {
      const cells = this.saleStats?.sales_by_weekday_hour || []
      if (!cells.length) return null
      const best = cells.reduce((top, cell) => (Number(cell.sales_count) > Number(top.sales_count) ? cell : top))
      const n = Number(best.sales_count)
      return this.$t('statistics.peak', { day: this.$t(`statistics.weekdays_long.${best.weekday}`), from: best.hour, to: Number(best.hour) + 1, n }, n)
    },
  },

  beforeUnmount() {
    window.removeEventListener('resize', this._onResize)
  },

  async mounted() {
    window.addEventListener('resize', this._onResize = () => {
      this.isMobile = window.innerWidth <= 767
    })
    this.isReady = false
    KTApp.initSelect2()
    // loadUserShops() doit résoudre AVANT initSelect() : voir le commentaire
    // équivalent dans Category.vue (select2 fige la liste d'options à son
    // init, les <option v-for> n'existent pas encore tant que shops est vide).
    await this.loadUserShops()
    if (this.shops && this.shops.length) {
      this.shop_selected = 'all'
    }
    await this.initSelect()
    this.initDateRange()
    let response = await this.getCurrency()
    this.iso = response?.data?.currency_symbol
    this.currency = response.data?.currency_symbol
      ? response.data?.currency_symbol
      : response.data?.symbol_native
  },

  methods: {
    employeeInitials(firstname, lastname) {
      const f = firstname?.[0] ?? ''
      const l = lastname?.[0] ?? ''
      return (f + l).toUpperCase() || '?'
    },
    employeeAvatarColor(i) {
      const colors = ['#F1416C22','#FFC70022','#0b3d8722','#7239EA22','#3699FF22','#50CD8922']
      return colors[i % colors.length]
    },
    ...mapActions('shop', ['getCurrency']),

    async loadUserShops() {
      await axios.get(`/dashboard/shops`)
        .then((response) => { this.shops = response.data.shops })
        .catch((error) => { console.log(error) })
    },

    async initSelect() {
      // Voir le commentaire équivalent dans Category.vue : select2 recopie
      // toujours les classes du <select> sur son <span> généré, il faut donc
      // qualifier par balise ("select.xxx") pour n'attraper que le vrai
      // <select> — sinon select2 s'initialise aussi sur le <span> et la
      // sélection ne se committe jamais.
      let kt_select = $('body select.kt_select_vente')
      kt_select.select2()
      kt_select.change((e) => {
        if (e.target.name === 'filter') {
          this.shop_selected = e.target.value
        }
      })
    },

    async loadStaticsCount() {
      if (this.shop_selected && this.startDate && this.endDate) {
        await axios.get(`/dashboard/statistics/count?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
          .then((response) => {
            this.contacts = response.data.contacts
            this.products = response.data.products
            this.contactTotal = response.data.contactTotal
            this.productTotal = response.data.productTotal
            this.turnover = this.$formatLocalAmount(response.data.turnover)
            this.turnoverTotal = response.data.turnoverTotal
          })
          .catch((error) => { console.log(error) })
      }
    },

    async loadSaleStats() {
      await axios.get(`/dashboard/statistics/vente?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
        .then((response) => {
          this.saleStats = response.data
          this.promotionStatData = response.data.promotionsData || []
        })
        .catch((error) => { console.log(error) })
    },

    async fetchPromotionStats() {
      if (!this.shop_selected || !this.startDate || !this.endDate) return
      await axios.get(`/get/stats/promotions?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
        .then((response) => { this.promotionStatData = response.data || [] })
        .catch((error) => { console.error(error) })
    },

    async fetchCodePromoStats() {
      if (!this.shop_selected || !this.startDate || !this.endDate) return
      await axios.get(`/get/stats/codes-promos?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
        .then((response) => { this.codePromoStatData = response.data || [] })
        .catch((error) => { console.error(error) })
    },

    // Impact des ventes de la fidélité sur la période sélectionnée (commandes
    // avec récompense appliquée, CA, remise accordée) — même filtre
    // boutique/période que promotions et codes promo, pas un solde de points.
    async fetchLoyaltyStats() {
      if (!this.shop_selected || !this.startDate || !this.endDate) return
      await axios.get(`/get/stats/loyalty?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
        .then((response) => { this.loyaltyStats = response.data || {} })
        .catch((error) => { console.error(error) })
    },

    async drawCharts() {
      this.isReady = false
      await this.loadStaticsCount()
      await this.loadSaleStats()
      await Promise.all([this.fetchPromotionStats(), this.fetchCodePromoStats(), this.fetchLoyaltyStats()])
      this.isReady = true
      await this.$nextTick()
      this.drawPeriodeSaleChart()
      this.drawTop5Chart()
      this.drawEmployeeSalesChart()
      this.initPromotionChart()
      this.initCodePromoChart()
    },

    // ── Charts ──────────────────────────────────────────

    drawPeriodeSaleChart() {
      if (this.salesChartPeriod) { this.salesChartPeriod.destroy(); this.salesChartPeriod = null }
      if (this.salesByPeriodEmpty) return
      const el = document.querySelector('#sale-periode-chart')
      if (!el) return

      const gray = KTUtil.getCssVariableValue('--bs-gray-500')
      const dashed = KTUtil.getCssVariableValue('--bs-border-dashed-color')
      const success = KTUtil.getCssVariableValue('--bs-success')
      const salesData = this.saleStats.sales_by_period

      this.salesChartPeriod = new ApexCharts(el, {
        series: [{ name: i18n.global.t('statistics.sale_by_period'), data: salesData.map(d => d.value) }],
        chart: { fontFamily: 'inherit', type: 'area', height: 300, toolbar: { show: false } },
        legend: { show: false },
        dataLabels: { enabled: false },
        fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.3, opacityTo: 0.7, stops: [0, 90, 100] } },
        stroke: { curve: 'smooth', show: true, width: 3, colors: [success] },
        xaxis: {
          categories: salesData.map(d => d.date),
          axisBorder: { show: false },
          axisTicks: { show: false },
          tickAmount: 6,
          labels: {
            rotate: -45,
            rotateAlways: false,
            hideOverlappingLabels: true,
            style: { colors: gray, fontSize: '11px' },
          },
          crosshairs: { position: 'front', stroke: { color: success, width: 1, dashArray: 3 } },
        },
        yaxis: { tickAmount: 4, labels: { style: { colors: gray, fontSize: '12px' } } },
        colors: [success],
        grid: { borderColor: dashed, strokeDashArray: 4, yaxis: { lines: { show: true } } },
        markers: { strokeColor: success, strokeWidth: 3 },
        tooltip: { style: { fontSize: '12px' }, y: { formatter: v => this.$formatLocalAmount(v) } },
        responsive: [{
          breakpoint: 576,
          options: {
            xaxis: { tickAmount: 4, labels: { rotate: -45, rotateAlways: true, style: { fontSize: '9px' } } },
          },
        }],
      })
      this.salesChartPeriod.render()
    },

    heatCount(day, hour) {
      return this.heatCells.get(`${day}-${hour}`) || 0
    },
    // Cinq niveaux de la même teinte ; 0 : case vide.
    heatLevel(count) {
      return count <= 0 || this.heatMax === 0 ? 0 : Math.min(5, Math.ceil((count / this.heatMax) * 5))
    },

    drawTop5Chart() {
      if (this.top5Chart) { this.top5Chart.destroy(); this.top5Chart = null }
      const salesData = this.saleStats?.top_products || []
      if (!salesData.length) return
      const el = document.getElementById('top5-articles-chart')
      if (!el) return

      const gray = KTUtil.getCssVariableValue('--bs-gray-500')
      const dashed = KTUtil.getCssVariableValue('--bs-border-dashed-color')
      const values = salesData.map(d => Number(d.sales))
      const maxVal = Math.max(...values)

      this.top5Chart = new ApexCharts(el, {
        series: [{ name: 'Ventes', data: values }],
        chart: { fontFamily: 'inherit', type: 'bar', height: 300, toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true, borderRadius: 4, dataLabels: { position: 'center' } } },
        dataLabels: {
          enabled: true,
          style: { colors: ['#fff'], fontSize: '12px', fontWeight: 600 },
          formatter: v => this.$formatLocalAmount(v),
        },
        xaxis: {
          categories: salesData.map(d => d.name),
          labels: { style: { colors: gray, fontSize: '12px' } },
          max: maxVal * 1.05,
        },
        yaxis: { labels: { style: { colors: gray, fontSize: '12px' } } },
        colors: ['#FFC700'],
        grid: { borderColor: dashed, strokeDashArray: 4, xaxis: { lines: { show: true } } },
        tooltip: { style: { fontSize: '12px' }, y: { formatter: v => this.$formatLocalAmount(v) + (this.currency ? ' ' + this.currency : '') } },
      })
      this.top5Chart.render()
    },

    drawEmployeeSalesChart() {
      if (this.employeeSalesChart) { this.employeeSalesChart.destroy(); this.employeeSalesChart = null }
      const salesData = this.saleStats?.sales_by_employee || []
      if (!salesData.length) return
      const el = document.getElementById('sales-employee-chart')
      if (!el) return

      const gray = KTUtil.getCssVariableValue('--bs-gray-500')
      const dashed = KTUtil.getCssVariableValue('--bs-border-dashed-color')

      const values = salesData.map(d => d.sales)
      const maxVal = Math.max(...values)

      this.employeeSalesChart = new ApexCharts(el, {
        series: [{ name: 'Ventes', data: values }],
        chart: { fontFamily: 'inherit', type: 'bar', height: 300, toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true, borderRadius: 4, dataLabels: { position: 'center' } } },
        dataLabels: {
          enabled: true,
          style: { colors: ['#fff'], fontSize: '12px', fontWeight: 600 },
          formatter: v => this.$formatLocalAmount(v),
        },
        xaxis: {
          categories: salesData.map(d => `${d.employee_lastname} ${d.employee_firstname}`),
          labels: { style: { colors: gray, fontSize: '12px' } },
          max: maxVal * 1.05,
        },
        yaxis: { labels: { style: { colors: gray, fontSize: '12px' } } },
        colors: ['#3E97FF'],
        grid: { borderColor: dashed, strokeDashArray: 4, xaxis: { lines: { show: true } } },
        tooltip: { style: { fontSize: '12px' }, y: { formatter: v => this.$formatLocalAmount(v) + (this.currency ? ' ' + this.currency : '') } },
      })
      this.employeeSalesChart.render()
    },

    initPromotionChart() {
      if (this.promotionChart) { this.promotionChart.destroy(); this.promotionChart = null }
      const el = document.getElementById('chartdiv_promotion')
      if (!el) return
      const data = this.promotionStatData || []
      if (!data.length) return

      const gray = KTUtil.getCssVariableValue('--bs-gray-500')
      const dashed = KTUtil.getCssVariableValue('--bs-border-dashed-color')

      this.promotionChart = new ApexCharts(el, {
        series: [
          { name: 'Ventes', data: data.map(d => Number(d.total_revenue || 0)) },
          { name: 'Réduction', data: data.map(d => Number(d.total_discount || 0)) },
        ],
        chart: { fontFamily: 'inherit', type: 'bar', height: 300, toolbar: { show: false } },
        plotOptions: { bar: { horizontal: false, borderRadius: 4, columnWidth: '55%' } },
        dataLabels: { enabled: false },
        xaxis: {
          categories: data.map(d => d.promotion),
          labels: { rotate: -45, style: { colors: gray, fontSize: '11px' } },
        },
        yaxis: { labels: { style: { colors: gray, fontSize: '12px' } } },
        colors: ['#009EF7', '#F1416C'],
        legend: { position: 'top' },
        grid: { borderColor: dashed, strokeDashArray: 4, yaxis: { lines: { show: true } } },
        tooltip: { style: { fontSize: '12px' }, y: { formatter: v => this.$formatLocalAmount(v) } },
      })
      this.promotionChart.render()
    },

    initCodePromoChart() {
      if (this.codePromoChart) { this.codePromoChart.destroy(); this.codePromoChart = null }
      const el = document.getElementById('chartdiv_codepromo')
      if (!el) return
      const data = this.codePromoStatData || []
      if (!data.length) return

      const gray = KTUtil.getCssVariableValue('--bs-gray-500')
      const dashed = KTUtil.getCssVariableValue('--bs-border-dashed-color')

      this.codePromoChart = new ApexCharts(el, {
        series: [
          { name: 'Ventes', data: data.map(d => Number(d.total_revenue || 0)) },
          { name: 'Réduction', data: data.map(d => Number(d.total_discount || 0)) },
        ],
        chart: { fontFamily: 'inherit', type: 'bar', height: 300, toolbar: { show: false } },
        plotOptions: { bar: { horizontal: false, borderRadius: 4, columnWidth: '55%' } },
        dataLabels: { enabled: false },
        xaxis: {
          categories: data.map(d => d.code_promo),
          labels: { rotate: -45, style: { colors: gray, fontSize: '11px' } },
        },
        yaxis: { labels: { style: { colors: gray, fontSize: '12px' } } },
        colors: ['#7239EA', '#FFC700'],
        legend: { position: 'top' },
        grid: { borderColor: dashed, strokeDashArray: 4, yaxis: { lines: { show: true } } },
        tooltip: { style: { fontSize: '12px' }, y: { formatter: v => this.$formatLocalAmount(v) } },
      })
      this.codePromoChart.render()
    },

    // ── Date range ──────────────────────────────────────

    initDateRange() {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]');
      let start = moment().subtract(29, 'days');
      let end = moment();

      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'), i18n.global.t('lu'), i18n.global.t('ma'), i18n.global.t('me'), i18n.global.t('je'), i18n.global.t('ve'), i18n.global.t('sa')],
          monthNames: [
            i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'),
            i18n.global.t('april'), i18n.global.t('may'), i18n.global.t('june'),
            i18n.global.t('july'), i18n.global.t('august'), i18n.global.t('september'),
            i18n.global.t('october'), i18n.global.t('november'), i18n.global.t('december')
          ],
          firstDay: 1
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      }, this.cb);

      this.cb(start, end);
    },

    async cb(start, end) {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]');
      let display = element.querySelector('div');
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY');
      }
      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')
      if (this.startDate && this.endDate) {
        await this.drawCharts()
      }
    },
  }
}
</script>

<style scoped>
/* Les heures de pointe : grille jour × heure, une teinte en cinq niveaux, case vide en gris très clair. */
.heatmap-scroll {
  overflow-x: auto;
}

.heatmap {
  display: grid;
  grid-template-columns: 36px repeat(var(--hours), minmax(18px, 1fr));
  gap: 3px;
  min-width: 480px;
}

.heatmap-hour {
  color: var(--bs-gray-500);
  font-size: 10px;
  text-align: center;
}

.heatmap-day {
  align-self: center;
  color: var(--bs-gray-600);
  font-size: 11px;
  font-weight: 600;
}

.heatmap-cell {
  height: 26px;
  border-radius: 4px;
  background: var(--bs-gray-100);
}

.heatmap-cell.level-1 { background: color-mix(in srgb, var(--bs-primary) 18%, #fff); }
.heatmap-cell.level-2 { background: color-mix(in srgb, var(--bs-primary) 38%, #fff); }
.heatmap-cell.level-3 { background: color-mix(in srgb, var(--bs-primary) 58%, #fff); }
.heatmap-cell.level-4 { background: color-mix(in srgb, var(--bs-primary) 80%, #fff); }
.heatmap-cell.level-5 { background: var(--bs-primary); }

.heatmap-legend {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 12px;
  color: var(--bs-gray-500);
  font-size: 11px;
}

.heatmap-legend .heatmap-cell {
  width: 16px;
  height: 12px;
}

.kpi-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  overflow: hidden;
}

.kpi-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #009EF7, #7239EA);
  border-radius: 12px 12px 0 0;
}

.kpi-icon-box {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kpi-big-number {
  font-size: 1.75rem;
  font-weight: 700;
  color: #181c32;
  line-height: 1.2;
  margin-bottom: 4px;
}

.dashboard-card {
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  border: none;
}

.section-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* ── Cards mobile (top 5 articles) ── */
.cat-stat-card {
  background: #f9f9f9;
  border: 1px solid #e4e6ef;
  border-radius: 10px;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
}
.cat-stat-name {
  font-size: 0.78rem;
  font-weight: 600;
  color: #5e6278;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.cat-stat-value { font-size: 1.1rem; font-weight: 700; line-height: 1.2; }
.cat-stat-currency { font-size: 0.7rem; font-weight: 500; opacity: 0.75; margin-left: 2px; }

/* ── Leaderboard mobile (ventes par caissier) ── */
.client-leaderboard { display: flex; flex-direction: column; gap: 8px; }
.leaderboard-row {
  display: flex; align-items: center; gap: 12px;
  padding: 10px 12px; border-radius: 10px;
  background: #f9f9f9; border: 1px solid #e4e6ef;
}
.leaderboard-row--gold   { background: #fffbea; border-color: #ffc700; }
.leaderboard-row--silver { background: #f4f4f4; border-color: #c0c0c0; }
.leaderboard-row--bronze { background: #fff5f0; border-color: #cd7f32; }
.leaderboard-rank { font-size: 1.3rem; width: 28px; flex-shrink: 0; text-align: center; }
.leaderboard-rank-num { font-size: 0.85rem; font-weight: 700; color: #a1a5b7; }
.leaderboard-avatar {
  width: 38px; height: 38px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.75rem; font-weight: 700; color: #3f4254;
  flex-shrink: 0; border: 1px solid rgba(0,0,0,0.06);
}
.leaderboard-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 5px; }
.leaderboard-name {
  font-size: 0.85rem; font-weight: 600; color: #1e2130;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.leaderboard-name-wrap {
  font-size: 0.85rem; font-weight: 600; color: #1e2130;
  word-break: break-word; line-height: 1.3;
}
.leaderboard-amount-below {
  font-size: 0.9rem; font-weight: 700; color: #0b3d87;
}
.leaderboard-amount-below small { font-size: 0.68rem; font-weight: 500; color: #a1a5b7; margin-left: 2px; }
.leaderboard-bar { height: 4px; background: #e4e6ef; border-radius: 2px; overflow: hidden; }
.leaderboard-bar-fill { height: 100%; border-radius: 2px; transition: width 0.4s ease; background: linear-gradient(90deg, #50CD89, #3699FF); }
.leaderboard-bar-fill--employee { background: linear-gradient(90deg, #0b3d87, #F1416C); }
.leaderboard-amount { font-size: 0.85rem; font-weight: 700; color: #1e2130; text-align: right; flex-shrink: 0; white-space: nowrap; }
.leaderboard-amount small { font-size: 0.65rem; font-weight: 500; color: #a1a5b7; margin-left: 2px; }

</style>
